function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 16.5L17 30.46 47 2.542",
  stroke: "#00EB84",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCheckSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 33,
    fill: "none"
  }, props), _ref);
}

export default SvgCheckSuccess;